<ngx-sds-login>
    <div appContent>
      <div>
        <!-- Tu contenido personalizado va aquí -->
        <div class="container-fluid">
          <div>
            <loader></loader>
          </div>
      
          <div class="row flex-nowrap">
            <div class="p-0 m-0" [class.col]="9">
              <main style="min-height: 100vh;">
                <app-menu-referente></app-menu-referente>
                <router-outlet></router-outlet>
              </main>
      
              <app-footer></app-footer>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <img appLogo src="assets/logo/car.png" alt="Logo">
</ngx-sds-login>
